// src/com/help/HelpData.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { AppPalette } from '../../model/AppConst';
import { useReactiveVar } from '@apollo/client';
import { currentMenuRepo } from '../../model/CvoModel';

const ArticleBox = styled(Box)({
    padding: 20,
    borderTop: '1px solid lightgray',
    marginBottom: 20,
});

const ArticleTitle = styled(Box)({
    fontSize: '1.1em',
    fontWeight: 'bold',
    marginBottom: 10,
    color: AppPalette.PrimaryRGB
});

const SmallTitle = styled(Box)({
    fontSize: '1em',
    color: AppPalette.SecondaryRGB,
    marginTop: 15,
    marginBottom: 5,
});

const ArticleContent = styled(Box)({
    fontSize: '0.95em',
    lineHeight: 1.5,
});

const SectionBox = styled(Box)({
    marginTop: 20, padding: 20,
    maxHeight: '70vh', overflowY: 'auto',
});

const SectionTitle = styled(Box)({
    fontSize: '1.25em',
    fontWeight: 'bold',
    marginBottom: 10,
});

export const HelpFlexTable = () => {
    return(
        <ArticleBox>
            <ArticleTitle>테이블 공통사항</ArticleTitle>
            <ArticleContent>
                <p>모든 테이블은 좌측상단에 <MenuIcon fontSize="small" style={{ verticalAlign: 'middle', }} /> 모양의 아이콘 메뉴가 있습니다.</p>
                <p>메뉴가 활성화되어 있는 경우 이 메뉴를 클릭하면 다음과 같은 메뉴가 나타날 수 있습니다.</p>
                <ul>
                    <li>엑셀다운로드 : 현재 테이블에 표시된 데이터 전체를 엑셀파일로 다운로드합니다.</li>
                    <li>클립보드 복사 : 현재 테이블에 표시된 데이터를 클립보드에 복사합니다.</li>
                    <li>컬럼설정 : 테이블에 표시할 컬럼을 선택하거나 순서를 변경할 수 있습니다.</li>
                    <li>데이터 다시 읽기 : 필요한 경우에만 나타나는 메뉴로 테이블의 데이터를 다시 불러옵니다. 단, 너무 잦은 다시 읽기는 허용되지 않습니다.(대개 5초)</li>
                </ul>
                <p>각 컬럼의 제목을 클릭하면 해당 컬럼을 기준으로 오름차순/내림차순 정렬이 가능합니다. (일부 컬럼은 정렬이 안될 수 있습니다.)</p>
                <p>컬럼의 우측끝에 마우스를 올려놓고 드래그하면 컬럼의 폭을 조절할 수 있습니다.</p>
                <SmallTitle>개별 레코드 관리</SmallTitle>
                <p>각 개별 레코드에 마우스가 올려지면 해당 레코드에 대한 추가적인 작업을 수행할 수 있는 메뉴가 오른쪽 끝에 나타납니다. 대개는 수정, 삭제, 상세보기 등이 있으며, 데이터 성격에 따라 달라집니다.
                </p>
            </ArticleContent>
        </ArticleBox>
    );
};

export const HelpCustInfo = () => {
    const menuInfo = useReactiveVar(currentMenuRepo);
    return(
        <SectionBox>
            <SectionTitle>{menuInfo.menuName}</SectionTitle>
            <ArticleBox>
                <ArticleTitle>개요</ArticleTitle>
                <ArticleContent>
                    <p>업체정보를 관리합니다. 업체목록의 각 업체에 대한 상세정보를 관리합니다. 개별 레코드에 마우스를 올려 
                        사용자/담당자 관리, 전반적인 관제정보 확인, 일시정지, 해지, 되살리기, 업체정보 수정 등의 작업을 할 수 있는 메뉴를 확인하고 사용하세요.
                    </p>
                </ArticleContent>
            </ArticleBox>
            <HelpFlexTable />
        </SectionBox>
    );
};